<template>
	<div class="newDetail_container">
		<!--{{ this.$route.query.plan}}-->
		<NavDetai />
		<BreadDetail />
		<section class="newDetail clearfix">
			<div class="newDetail_left">
				<div class="newDetail_title">
					{{productDetailData.title}}
				</div>
				<!-- <div class="data_time"><span>时间:</span><span>{{productDetailData.newsDate | data(".") }}</span></div> -->
				<div class="content newcontent" v-html="productDetailData.detail"></div>
				<div class="page">
					<div class="pageUp" v-show="prevPage" @click="goProductDetail(prevPage.id)"><span>上一篇：</span>{{prevPage ? prevPage.title:""}}</div>
					<div class="pageDown" v-show="nextPage" @click="goProductDetail(nextPage.id)"><span>下一篇：</span>{{nextPage ? nextPage.title:""}}</div>
				</div>
			</div>
			<div class="newDetail_right">
				<!--分享到开始-->
				<div class="share">
					<div class="titile">分享到</div>
					<div class="share_type">
						<img src="~@/assets/image/share_sina.png" alt="" width="40" height="40" class="sina" @click="shareTo('sina')" />
						<img src="~@/assets/image/share_wx.png" alt="" width="40" height="40" class="wx" @click="shareTo('wx')" style="display: none" />
						<img src="~@/assets/image/share_QQ.png" alt="" width="40" height="40" class="QQ" @click="shareTo('QQ')" />
					</div>
				</div>
				<!--分享到结束-->
				<!--相关内容-->
				<div class="relevant">
					<div class="titile">相关内容</div>
					<ul class="relevant_list">
						<li v-for="(item,index) in doFilter" :key="index" @click="goProductDetail(item.id)">
							<div class="subtitle">{{item.title}}</div>
							<div class="content">{{item.content}}</div>
						</li>
					</ul>
				</div>

			</div>
		</section>
	</div>
</template>

<script>
	import NavDetai from '@/components/NavDetai.vue';
	import BreadDetail from '@/components/BreadDetail.vue';
	import {API_HOST} from '@/assets/Utils/api/config.js'
	import { 
    	GetProductsDynamicList 
  } from '../Product/Product.model';
	import {
		GetProductDetail
	} from './ProductDetail.model'
	export default {
		name: "ProductDetail",
		components: {
			NavDetai,
			BreadDetail
		},
		// metaInfo: {
		//   title: '动态详情', // set a title
		//   meta: [{                 // set meta
		//     name: '',
		//     content: '动态详情'
		//   }],
		//   link: [{                 // set link
		//     rel: 'asstes',
		//     href: 'http://www.fjyszn.com/'
		//   }]
		// },
		metaInfo() {
			return {
				title: this.productDetailData.title,
				meta: [{ // set meta
					name: this.productDetailData.title,
					content: this.productDetailData.content
				}],
				link: [{ // set link
					rel: 'asstes',
					href: API_HOST + '/#/ProductDetail?plan=' + this.$route.query.plan
				}]
			}
		},
		data() {
			return {
				id: 0,
				productDetailData: {},
				DynamicData: [],
				prevData: {},
				nextData: {},
				productDynamicData: []
			}
		},
		mounted() {
			this.getData();
			this.getPageData();
		},
		methods: {
			goProductDetail(productId) {
				this.$router.push({
					path: '/ProductDetail',
					query: {
						plan: productId
					}
				});
				this.getData();
			},
			async getData() {
				let DynamicParam = {
					page: 1,
					limit: 5
				};
				const productDetailData = await GetProductDetail(this.$route.query.plan);
				this.productDetailData = productDetailData.data;
				const DynamicProducts = await GetProductsDynamicList(DynamicParam);
				this.DynamicData = DynamicProducts.data.list;
			},
			async getPageData() {
				let DynamicParam = {
					page: 1,
					limit: 0
				};
				const DynamicProducts = await GetProductsDynamicList(DynamicParam);
				this.productDynamicData = DynamicProducts.data.list;
			},
			shareTo(type) {
				switch (type) {
					case 'sina':
						{
							return;
							window.open('http://service.weibo.com/share/share.php?url=' + document.location.href +
								'?sharesource=weibo&title=' + this.productDetailData.title + '&pic=' + this.productDetailData.imageUr +
								'&appkey=2706825840');
							break
						};
					case 'wx':
						{
							// console.log(type);
							break
						}
					case 'QQ':
						{
							// console.log(this.productDetailData);
							return;
							var that = this;
							window.open("https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + document.location.href +
								"&sharesource=qzone&title=" + that.productDetailData.title + "&pics=" + that.productDetailData.imageUr + "&summary=" +
								that.productDetailData.content);
							break
						}
				}
			},
			findIndex(array, findId) {
				for (var i = 0; i < array.length; i++) {
					if (array[i].id == findId) {
						return i;
						break;
					}
				}
				return -1;
			}
		},
		computed: {
			doFilter() {
				var currentIndex = this.$route.query.plan;
				return this.DynamicData.filter(function(item, index) {
					return (index + 1) != currentIndex;
				});
			},
			prevPage() {
				var prvIndex = this.findIndex(this.productDynamicData, this.$route.query.plan);
				return this.productDynamicData[prvIndex - 1];
			},
			nextPage() {
				var nextIndex = this.findIndex(this.productDynamicData, this.$route.query.plan);
				return this.productDynamicData[nextIndex + 1] ? this.productDynamicData[nextIndex + 1] : null;
			}
		}
	}
</script>

<style scoped lang="less">
	.newDetail_container {
		margin-top: 100px;
	}

	.newDetail {
		width: 1240px;
		margin: 0 auto;
		text-align: left;

		.newDetail_left {
			width: 820px;
			float: left;

			/deep/img {
				max-width: 100% !important;
			}
		}

		.content {
			font-size: 14px;
			font-weight: 400;
			color: rgba(128, 128, 128, 1);
			line-height: 30px;
		}

		.newDetail_title {
			font-size: 30px;
			font-weight: 600;
			color: rgba(51, 51, 51, 1);
			line-height: 36px;
		}

		.data_time {
			font-size: 16px;
			font-weight: 400;
			color: #4D4D4D;
			margin: 20px auto 13px;
			border-bottom: 1px solid #E6E6E6;
			padding-bottom: 37px;
		}

		.share_type {
			padding: 25px 0;
			border-bottom: 1px solid #E6E6E6;
			margin-bottom: 25px;

			img {
				margin-right: 52px;
			}
		}

		.page {
			font-size: 14px;
			font-weight: 500;
			color: rgba(77, 77, 77, 1);
			line-height: 18px;
			margin-bottom: 120px;

			div {
				&:hover {
					color: #39B2EC;
				}
			}

			.pageUp {
				margin-top: 50px;
			}

			.pageDown {
				margin-top: 20px;
			}
		}

		.newDetail_right {
			width: 360px;
			float: right;

			.titile {
				font-size: 16px;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
				line-height: 20px;
				position: relative;
				text-indent: 16px;

				&::before {
					content: " ";
					width: 4px;
					height: 16px;
					background: #39B2EC;
					position: absolute;
					top: 3px;
					left: 0px;
				}
			}
		}

		.relevant {}

		.relevant_list {
			li {
				padding-bottom: 30px;
				border-bottom: 1px solid #E6E6E6;
				cursor: pointer;
			}

			.subtitle {
				font-size: 20px;
				font-weight: 600;
				color: rgba(51, 51, 51, 1);
				line-height: 24px;
				margin: 30px auto 12px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;

			}

			.content {
				font-size: 14px;
				font-weight: 400;
				color: rgba(128, 128, 128, 1);
				line-height: 30px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
			}
		}

		/deep/.vjs-fluid {
			padding-top: 0;
			height: 100%;
			width: 100%;
		}
	}
</style>
